import React from "react";
import { Button, Icon, Wrapper } from "app/NativeComponents/common";

import { dismissMobileKeyboard, getMyLocation } from "app/NativeActions";

const LocationButton = props => {
  return (
    <Button
      onPress={() => {
        dismissMobileKeyboard();
        props.selectActiveProperty(props.token, null);
        if (!props.lock_location_tracking) {
          getMyLocation({
            success: coordinates => {
              props.updateMapLocation({
                coordinates: coordinates,
                active_property: null
              });
            },
            onError: () => {
              props.lockLocationTracking(false);
            }
          });
        }

        props.lockLocationTracking(!props.lock_location_tracking);
      }}
      style={{
        width: 50,
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Icon
        icon={props.lock_location_tracking ? "navigation" : ""}
        fa_icon={!props.lock_location_tracking ? "location-arrow" : ""}
        color={
          props.lock_location_tracking
            ? props.colors.active_color
            : props.colors.text_color
        }
        size={18}
      />
    </Button>
  );
};

export default React.memo(LocationButton);
